import axios from "axios";
import BaseService from "./baseService";
import { StackReportScenarioFilter, StackReportDashboardRequest } from "store/stackReportDashboard/types";
import { DumpFileComparisonParams, FetchRowsParams } from "store/comparerDshb/types";

export default class DashboardService extends BaseService {
    constructor() {
        super("dashboard");
    }

    /**
     * Gets scenarios for dashboard-based reporting screens.
     * Used by stack report, comparer dashboard and map dashboard.
     * @param filter Dashboard scenario filter
     * @returns list of scenarios
     */
    getScenarios = (filter: StackReportScenarioFilter) => this.httpPostRequest("scenarios", filter);

    /**
     * Loads scenarios into one or more dashboards.
     * @param data Scenario ids and target dashboard ids
     * @returns void
     */
    loadScenarios = (data: {
        scenarioIds: number[];
        dashboards: number[];
    }) => this.httpPostRequest("loadScenarios", data);

    /**
     * Gets dashboard payload for reporting.
     * Used by stack report, comparer and map dashboard.
     * @param data Dashboard request with selected tables and filters
     * @returns dashboard payload
     */
    getDashboard = (data: StackReportDashboardRequest) => this.httpPostRequest("getDashboard", data);

    /**
     * Gets map settings for map dashboard.
     * @param taskId Task identifier
     * @returns map settings
     */
    getMapSettings = (taskId: number) => this.httpGetRequest(`getMapSettings/${taskId}`);

    /**
     * Downloads file content S3 url.
     * @param url file url
     * @returns string
     */
    getS3File = (url: string) => axios.get(url);

    /**
     * Gets comparison file list for two scenarios.
     * @param data Source and target scenario identifiers
     * @returns list of compared files
     */
    getComparedFiles = (data: {
        sourceId: number;
        targetId: number;
    }) => this.httpPostRequest("getComparisonFilesList", data);

    /**
     * Gets row-level file comparison result.
     * @param data Row comparison request payload
     * @returns row comparison result
     */
    getComparedRows = (data: FetchRowsParams) => this.httpPostRequest("fileComparison", data);

    /**
     * Generates downloadable file comparison report.
     * @param filter Download request payload
     * @returns file url
     */
    dumpFileComparison = (filter: DumpFileComparisonParams) => this.httpPostRequest("dumpFileComparison", filter);
}
